import { defineStore } from 'pinia';

export const useMainStore = defineStore('main', {
  state: () => ({
    tariffPlan: 0, // Initial value for the tariff plan
  }),
  actions: {
    setTariffPlan(value) {
      this.tariffPlan = value; // Update the tariff plan
    },
  },
});
